<template lang="html">
  <a
    ref="button"
    v-tracking-context="{ id: jobId }"
    :href="href"
    target="_blank"
    rel="nofollow noopener noreferrer"
    :class="classes"
    @click="openModal"
  >
    <button
      :disabled="disabled"
      class="button button--primary button--bold"
      :class="buttonClasses"
    >
      {{ 'client.apply_button' | t }}
    </button>
  </a>
</template>

<script>
import ApplyModalContent from './apply_modal_content'
import { mapActions } from 'vuex'

export default {
  props: {
    classes: {
      type: String,
      default: ''
    },
    buttonClasses: {
      type: String,
      default: ''
    },
    applyEmail: {
      type: String,
      default: null
    },
    applyUrl: {
      type: String,
      default: null
    },
    directApply: {
      type: Boolean,
      default: null
    },
    jobId: {
      type: String,
      default: null
    },
    jobTitle: {
      type: String,
      default: null
    },
    jobEmployer: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    href() {
      return this.directApply
        ? '#job_application_form'
        : this.applyUrl || '#apply_modal'
    }
  },
  methods: {
    ...mapActions(['trackGoogleTagManagerEvent']),
    openModal($event) {
      EventBus.trigger('tracking:manualEventTrack', {
        action_type: 'apply',
        $elem: $(this.$refs.button)
      })
      this.trackGoogleTagManagerEvent({ action: 'applicationIntent' })

      if (this.applyUrl) {
        // Do nothing and let the browser handle the link
        return null
      }

      $event.preventDefault()

      if (this.directApply) {
        this.$store.commit('modalOpen', {
          component: () =>
            import(/* webpackPrefetch: true */ './email_application_modal'),
          props: this.$props
        })
      } else {
        this.$store.commit('modalOpen', { component: ApplyModalContent })
      }
    }
  }
}
</script>
